import LANGUAGE_NAMES from '../../../../lang/languages.json';
/**
 * The one tenant whose interface can be Arabic (Robert: Arabic is for
 * MalkaVCS only). A MalkaVRS, MalkaVRI, Maple or Terp surface never shows
 * Arabic, also with an Arabic browser. The interpretation and transcription
 * language contracts do not use this rule.
 */
export const ARABIC_UI_TENANT = 'malkavcs';
/** The hosts that serve the MalkaVCS tenant (whitelabel/malkavcs.json domains). */
const ARABIC_UI_HOSTS = ['app.malkacomm.com'];
const ARABIC = /^ar(?:$|[-_]|[a-z]{2}$)/i;
/**
 * Whether the page runs on a MalkaVCS host. Native builds have no MalkaVCS
 * app, so they never open Arabic.
 *
 * @returns {boolean}
 */
export function isArabicUiHost() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
        return false;
    }
    const hostname = typeof window === 'undefined' ? '' : window.location?.hostname;
    return typeof hostname === 'string' && ARABIC_UI_HOSTS.includes(hostname.toLowerCase());
}
/**
 * Whether a tenant can show its interface in Arabic.
 *
 * @param {string} [tenantId] - The tenant id. Without it, the page host decides.
 * @returns {boolean}
 */
export function isArabicUiTenant(tenantId) {
    return tenantId === undefined ? isArabicUiHost() : tenantId === ARABIC_UI_TENANT;
}
/**
 * The interface language for a requested language: Arabic only for the
 * MalkaVCS tenant, English for every other tenant.
 *
 * @param {string} language - A BCP-47 locale or the detector's compact form (arSA).
 * @param {string} [tenantId] - The tenant id. Without it, the page host decides.
 * @returns {string}
 */
export function resolveUiLanguage(language, tenantId) {
    return ARABIC.test(language) && !isArabicUiTenant(tenantId) ? 'en' : language;
}
/**
 * The interface languages of a tenant.
 *
 * @param {string} [tenantId] - The tenant id. Without it, the page host decides.
 * @returns {string[]}
 */
export function uiLanguagesFor(tenantId) {
    return Object.keys(LANGUAGE_NAMES).filter(language => resolveUiLanguage(language, tenantId) === language);
}
export const UI_LANGUAGES = uiLanguagesFor();
